(ns common.db.coeffects.query-params
  (:require [common.url :as url]
            [re-frame.core :as rf]))

(defn query-params
  "Return a map of query params for current url

   Example:

   ```clojure
   (rf/reg-event-fx :sample-event
    [(rf/inject-cofx :query-params)]
    (fn [{:keys [query-params]}]
      ...))
   ```"
  [cofx]
  (assoc cofx :query-params (url/query-string->map
                             (.getQuery (url/current-uri)))))

(rf/reg-cofx :query-params query-params)
